import { GetPlanList } from '@src/services/plan'

export const state = {
    panelContent: {},
    planList: [],
}

export const getters = {}

export const mutations = {
    SET_PANEL_CONTENT(state, content) {
        state.panelContent = content
    },
    SET_PLAN_LIST(state, list) {
        state.planList = list
    },
}

export const actions = {
    setPanelContent({ commit }, content) {
        commit('SET_PANEL_CONTENT', content)
    },
    async getPlanList({ commit }, parameters = {}) {
        const resp = await GetPlanList(parameters)
        if (resp.status === 200) {
            commit('SET_PLAN_LIST', resp.data.data.items)
        }
        return resp
    },
}
